import { render, staticRenderFns } from "./AdminServiceAreaAttributeForm.vue?vue&type=template&id=7ef3975f"
import script from "./AdminServiceAreaAttributeForm.vue?vue&type=script&lang=js"
export * from "./AdminServiceAreaAttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports